import React from "react";
// import { DotLottieReact } from "@lottiefiles/dotlottie-react";
// import { Link } from "react-router-dom";
// import brain from "../assets/animations/brain.lottie";
// import heroVideo from "../assets/heroVideo.mp4";
import SplitText from "./SplitText";

function Hero() {
	return (
		<section id="hero" className="desktopMaxWidth hero">
			<div className="heroLeftContainer">
				<SplitText />
				{/* <p className="heroText">
					<span className="span1">Focus</span> on what you can
					<span className="span2"> Control</span> as the foundation of your
					<span className="span2"> Healing</span>,
					<span className="span3"> Growth</span> and
					<span className="span4"> Wellbeing.</span>
				</p> */}

				{/* <div className="buttonsContainer">
					<Link to="/contact" className="getStarted cta">
						Book Now
					</Link>
					<Link to="/about" className="learnMore cta ctaSecondary ctaThird">
						Learn More
					</Link>
				</div> */}
			</div>
			{/* 
			<video
				className="heroRightContainer"
				autoPlay
				loop
				muted
				playsInline
				src={heroVideo} // Update with your video path
				alt="Woman in a counseling session"
			>
				Your browser does not support the video tag.
			</video> */}

			{/* <div className="heroRightContainer">
				<DotLottieReact
					src={brain}
					loop
					autoplay
					style={{
						backgroundColor: "transparent",
						width: "100%",
						height: "100%",
					}}
				/>
			</div> */}
		</section>
	);
}

export default Hero;
